import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import RobotoSlabRegular from "./RobotoSlab-Regular.woff2";
import RobotoSlabBold from "./RobotoSlab-Bold.woff2";

export const RobotoSlabFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: RobotoSlabRegular,
    descriptors: {
      weight: "400",
      style: "normal",
    },
  },
  {
    uri: RobotoSlabBold,
    descriptors: {
      weight: "700",
      style: "normal",
    },
  },
];
